
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCellFull as ObiCellFullElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cell-full.js';
 
 
 

 
 export const ObiCellFull = createComponent({
   react: React,
   tagName: 'obi-cell-full',
   elementClass: ObiCellFullElement,
   events: {
     
   }
  });
 
 